import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/services/auth.service';
import { LoadingService } from 'src/app/services/loading.service';
import { SidenavService } from 'src/app/services/sidenav.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

    constructor(
        public sidenav: SidenavService,
        private auth: AuthService,
        private modalService: NgbModal
    ) { }

    @ViewChild('logoutModal') logoutModal: any;
    userData: any = {};
    lModal: any;
    loading = false;

    logout(): void {
        this.lModal = this.modalService.open(this.logoutModal, { backdrop: 'static', keyboard: false, centered: true });
    }

    goLogout(): void {
        this.loading = true;
        this.auth.logout().then((s: any) => {
            this.lModal.close();
            this.loading = false;
        });
    }

    ngOnInit(): void {
        this.userData = this.auth.userData;
    }

}
